
































































import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    JobPageDataType,
    JoblistPageDataType,
    componentDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    FETCH_JOB_DATA,
    FETCH_CHILDREN
    // FETCH_JOBLIST_DATA
} from "../store/actions.names";
import {
    SET_JOB_CURRENT_PAGE,
    SET_JOB_DATA,
    CURRENT_PAGE_ERROR,
    SET_JOB_PARENT_PAGE,
} from "../store/mutations.names";
import axios from "axios";
import {
    TimelineMax,
    Power1,
    Expo,
    Power2,
    Power4
} from "gsap";
import BannerTextBlock from "../components/BannerTextBlock.vue";
import TitleText from '../components/TitleText.vue';
import JobBtn from '../components/JobBtn.vue';
import JobCategory from "../components/JobCategory.vue";
//import JobApplication from "../components/JobApplication.vue";
import AOS from "aos";
@Component({
    name: 'JobIndexPage',
    components: {
        banner: BannerTextBlock,
        title_text: TitleText,
        job_details_cta: JobBtn,
        JobCategory
        // employee_job_apply_form: JobApplication
        // campaign_block: CampaignCard
        // BannerText,
        // CampaignLCards,
        // CampaignRCards,
        // Footer,
    },
})
export default class JobIndexPage extends Vue {
    @Getter("jobData") public jobData!: JobPageDataType[];
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_JOB_DATA) public fetchData: any;
    @Action(FETCH_CHILDREN)[FETCH_CHILDREN]: any;
    @Mutation(SET_JOB_CURRENT_PAGE) public[SET_JOB_CURRENT_PAGE]: any;

    //JOB LIST
    // @Getter("joblistData") public joblistData!: JoblistPageDataType[];
    // @Action(FETCH_JOBLIST_DATA) public fetchlistData: any;
    // @Mutation(SET_JOBLIST_CURRENT_PAGE) public[SET_JOBLIST_CURRENT_PAGE]: any;

    public HOST: string = HOST;
    activetab = 1;
    posts = [];
    jobCategories: any[] = [];
    // public created() {
    //     this.jobData.forEach(joblist => {
    //     axios.get(`${API_URL}/pages/?child_of=${(this as any).joblist.id}`)
    //         .then(response => {
    //             (this as any).posts = response.data
    //         })
    //         .catch(e => {
    //             (this as any).errors.push(e)
    //         })
    //   });

    //}

    public created() {
        AOS.init();
    }
    public positiontop() {
        AOS.init();
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
    public mounted() {
        this[FETCH_CHILDREN](this.pageData.id)
            .then((resp: any) => {
                this.jobCategories = resp.items;
            })
        this.positiontop();
        // this.fetchData(this.pageData.id);
        // this[FETCH_JOB_DATA]();
        // this.jobData.map((joblist: any) => {
        //     return axios.get(`${API_URL}/pages/?child_of=${joblist.id}`)

        //         .then(response => {

        //             // JSON responses are automatically parsed.
        //             (this as any).posts = response.data

        //         })
        //         .catch(e => {
        //             (this as any).errors.push(e)
        //         })
        // });
        //this.fetchlistData(this.pageData.id);
        //  this.jobData.map((joblist: any) => {
        //     console.log(this.joblist);
        // });
        //    console.log(this.joblist.id);
    }

}
